module.exports = __webpack_public_path__ + "static/media/logo.abfb9528.png";